

import React, { memo } from 'react';
import cx from 'classnames';
import Icon from '../../../Icon';
import { HEADER, ICON_WRAPPER, HEADER_TEXT } from '../../styles/navModal';
import Text from '../../../Text';







/**
   * A modal header component
   *
   * @return {React.Element}
   */
function ModalHeader({ hideIcon, title, subtitle }) {
  return (
    <div className={cx(HEADER, 'modal__header')}>
      {
      hideIcon ?
      null :

      <div className={cx(ICON_WRAPPER, 'modal__icon-wrapper')}>
              <Icon name="template" color="white" size={15} />
            </div>}


      <div className={cx(HEADER_TEXT, 'modal__header__text')}>
        <Text heading4 noMargin>{title}</Text>
        <Text noMargin>{subtitle}</Text>
      </div>
    </div>);

}

export default memo(ModalHeader);